import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
// import App from './App_single_routing';
// import App from './App_multi_routing';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// import reportWebVitals from './reportWebVitals';
// import 'bootstrap/dist/css/bootstrap.min.css';
import "src/assets/style.css";
import "src/assets/icons.css";
import "src/assets/buttons.css";
import "src/assets/tables.css";
import "src/assets/inputs.css";
import "src/assets/labels.css";
import "src/assets/selects.css";
import "src/assets/cards.css";
import "src/assets/graphs.css";
import 'bootstrap/dist/css/bootstrap.css';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

const a = require("./" + process.env.REACT_APP_ROUTING);
const App = a?.default
// const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
// console.log(process.env.REACT_APP_ROUTING)
const rootElement = document.getElementById('root', {
  onCaughtError: (error, errorInfo) => {
    console.error(
      'Caught error',
      error,
      errorInfo.componentStack
    );
  }
});
const root = createRoot(rootElement);
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// chenges on core/develop
// chenges on core/develop second

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.register();
// serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
